import { combineReducers } from 'redux';
import AuthReducer from './gl_auth_reducer/reducer';
import CommonReducer from './gl_common_reducer/reducer';
import FCMReducer from './gl_fcm_reducer/reducer';
import HostReducer from './gl_host_provider/reducer';
import ModalReducer from './gl_modal_reducer/reducer';
import NavigationReducer from './gl_navigation_reducer/reducer';
import ThemeReducer from './gl_theme_reducer/reducer';
import TranslationReducer from './gl_translations_reducer/reducer';

// ASYNC REDUCERS
import UserProfileReducer from 'scenes/ClientAccount-Profile_page/store/reducer';
import ClientAccountReducer from 'scenes/ClientAccount_page/store/reducer';
import ForgotPasswordReducer from 'scenes/ForgotPassword_page/store/reducer';
import PropertyBasicInfoReducer from 'scenes/ProductEdit-Basicdetails_page/store/reducer';
import ProductDocumentsReducer from 'scenes/ProductEdit-Documents_page/store/reducer';
import ProductImagesReducer from 'scenes/ProductEdit-Images_page/store/reducer';
import ProductReducer from 'scenes/ProductEdit_page/store/reducer';
import ProductsReducer from 'scenes/Products_page/store/reducer';
import ProductsReducerMobile from 'scenes/Products_page_mobile/store/reducer';
import RegisterReducer from 'scenes/Register_page/store/reducer';
import ResetPasswordReducer from 'scenes/ResetPassword_page/store/reducer';
import SecurityReducer from 'scenes/Security_page/store/reducer';

import AppointmentsReducer from 'scenes/ClientAccount-Appointment_page/store/reducer';
import ClientListReducer from 'scenes/ClientListing_page/store/reducer';
import ProductNotesReducer from 'scenes/ProductEdit-Notes_page/store/reducer';
import ClientDetailsReducer from 'scenes/SingleClient-Clientdetails_page/store/reducer';
import ClientDocumentsReducer from 'scenes/SingleClient-Documents_page/store/reducer';
import ClientNotesReducer from 'scenes/SingleClient-InternalNotes_page/store/reducer';
import TaskReducer from 'scenes/Task_page/store/reducer';

import ProductsFilterReducer from 'components/molecules/ProductFilter/store/reducer';
import ChatReducer from 'scenes/Chat_page/store/reducer';
import ClientAccountFavoritesReducer from 'scenes/ClientAccount-Favorites_page/store/reducer';
import ClientSavedSearchesReducer from 'scenes/ClientAccount-SavedSearches_page/store/reducer';
import HomeReducer from 'scenes/Home_page/store/reducer';
import ProductDetailsReducer from 'scenes/ProductDetails_page/store/reducer';
import SingleClientRequestReducer from 'scenes/SingleClient-ClientRequest_page/store/reducer';
import ClientCollectionReducer from 'scenes/SingleClient-Propertycollections_page/store/reducer';
import SingleClientSavedSearchesReducer from 'scenes/SingleClient-Savedsearch_page/store/reducer';

import BlogsReducer from 'scenes/Blogs_page/store/reducer';
import CategoryEditReducer from 'scenes/CategoryEdit_page/store/reducer';
import ClientPublicNotesReducer from 'scenes/SingleClient-PublicNotes_page/store/reducer';
import ClientTaskReducer from 'scenes/SingleClient-Task_page/store/reducer';
import StoresReducer from 'scenes/Stores_page/store/reducer';
import TopicEditReducer from 'scenes/TopicEdit_page/store/reducer';
import TopicReducer from 'scenes/Topics_page/store/reducer';
import { ReducerKeys } from '../config';

import BlogEditReducer from 'scenes/BlogEdit_page/store/reducer';
import SpecificationAttributeEditReducer from 'scenes/SpecificationAttributeEdit_page/store/reducer';
import StoreEditReducer from 'scenes/StoresEdit_page/store/reducer';

import NewsReducer from 'scenes/News_page/store/reducer';
import BlogShowDetailReducer from 'scenes/ShowBlogDetail_page/store/reducer';
import BlogShowReducer from 'scenes/ShowBlog_page/store/reducer';
import NewsShowDetailReducer from 'scenes/ShowNewsDetail_page/store/reducer';
import NewsShowReducer from 'scenes/ShowNews_page/store/reducer';
import TopicShowDetailReducer from 'scenes/ShowTopicDetail_page/store/reducer';

import NewEditReducer from 'scenes/NewEdit_page/store/reducer';
import SettingsAdditionalReducer from 'scenes/Setting_Additional_page/store/reducer';
import SettingsGeneralReducer from 'scenes/Setting_General_page/store/reducer';

import ViewTaskReducer from 'components/app_common/ViewTask2/store/reducer';
import ViewUserInfoReducer from 'components/compounds/ViewUserInfo/store/reducer';
import DashboardReducer from 'scenes/Dashboard_page/store/reducer';
import DocumentEditReducer from 'scenes/DocumentEdit_page/store/reducer';
import DocumentListReducer from 'scenes/Documents_page/store/reducer';
import ProductPrintPdfReducer from 'scenes/ProductPrintPdf_page/store/reducer';
import ReportingReducer from 'scenes/Reporting_page/store/reducer';

import SendMailReducer from 'components/app_common/SendMailModal/store/reducer';
import SingleClientLocationReducer from 'scenes/SingleClient-ClientLocation/store/reducer';

// const authPersistConfig = {
//   key: ReducerKeys.AUTH_REDUCER,
//   storage: storage,
//   blacklist: ['status'],
// };

// const translationPersistConfig = {
//   key: ReducerKeys.TRANSL_REDUCER,
//   storage: storage,
// };

// const navigationPersistConfig = {
//   key: ReducerKeys.NAVIGATION_REDUCER,
//   storage: storage,
// };

// const themePersistConfig = {
//   key: ReducerKeys.THEME_REDUCER,
//   storage: storage,
//   // blacklist: ['accessFromMobileApp'],
// };

export const asyncReducers = {
  [ReducerKeys.REGISTER_REDUCER]: RegisterReducer,
  [ReducerKeys.USER_PROFILE_REDUCER]: UserProfileReducer,
  [ReducerKeys.CLIENT_ACCOUNT_REDUCER]: ClientAccountReducer,

  [ReducerKeys.CHANGE_PASSWORD_REDUCER]: SecurityReducer,
  [ReducerKeys.RESET_PASSOWRD_REDUCER]: ResetPasswordReducer,
  [ReducerKeys.FORGOT_PASSWORD_REDUCER]: ForgotPasswordReducer,
  [ReducerKeys.PRODUCTS_REDUCER]: ProductsReducer,
  [ReducerKeys.PRODUCTS_REDUCER_MOBILE]: ProductsReducerMobile,
  [ReducerKeys.PRODUCT_REDUCER]: ProductReducer,
  [ReducerKeys.PROPERTY_BASICINFO_REDUCER]: PropertyBasicInfoReducer,
  [ReducerKeys.PRODUCT_IMAGES_REDUCER]: ProductImagesReducer,
  [ReducerKeys.PRODUCT_DOCUMENTS_REDUCER]: ProductDocumentsReducer,
  [ReducerKeys.PRODUCT_NOTES_REDUCER]: ProductNotesReducer,
  [ReducerKeys.CLIENT_LIST_REDUCER]: ClientListReducer,
  [ReducerKeys.TASK_REDUCER]: TaskReducer,
  [ReducerKeys.APPOINTMENTS_REDUCER]: AppointmentsReducer,
  [ReducerKeys.DASHBOARD_REDUCER]: DashboardReducer,

  [ReducerKeys.CLIENT_DETAILS_REDUCER]: ClientDetailsReducer,
  [ReducerKeys.PRODUCT_FILTER_REDUCER]: ProductsFilterReducer,
  [ReducerKeys.CLIENT_NOTES_REDUCER]: ClientNotesReducer,
  [ReducerKeys.CLIENT_PUBLIC_NOTES_REDUCER]: ClientPublicNotesReducer,
  [ReducerKeys.CLIENT_DOCUMENTS_REDUCER]: ClientDocumentsReducer,
  [ReducerKeys.HOME_REDUCER]: HomeReducer,
  [ReducerKeys.PRODUCT_DETAILS_REDUCER]: ProductDetailsReducer,
  [ReducerKeys.CLIENT_FAVORITES_REDUCER]: ClientAccountFavoritesReducer,
  [ReducerKeys.CLIENT_SAVED_SEARCHES_REDUCER]: ClientSavedSearchesReducer,
  [ReducerKeys.SINGLE_CLIENT_SAVED_SEARCHES_REDUCER]:
    SingleClientSavedSearchesReducer,
  [ReducerKeys.CLIENT_COLLECTION_REDUCER]: ClientCollectionReducer,
  [ReducerKeys.SINGLE_CLIENT_REQUEST_REDUCER]: SingleClientRequestReducer,
  [ReducerKeys.SINGLE_CLIENT_LOCATION_REDUCER]: SingleClientLocationReducer,
  [ReducerKeys.CHAT_REDUCER]: ChatReducer,
  [ReducerKeys.CATEGORY_EDIT_REDUCER]: CategoryEditReducer,
  [ReducerKeys.CLIENT_TASK_REDUCER]: ClientTaskReducer,
  [ReducerKeys.TOPIC_REDUCER]: TopicReducer,
  [ReducerKeys.TOPIC_EDIT_REDUCER]: TopicEditReducer,
  [ReducerKeys.BLOGS_REDUCER]: BlogsReducer,
  [ReducerKeys.STORES_REDUCER]: StoresReducer,

  [ReducerKeys.BLOG_EDIT_REDUCER]: BlogEditReducer,
  [ReducerKeys.STORES_EDIT_REDUCER]: StoreEditReducer,

  [ReducerKeys.SPECIFICATION_ATTRIBUTE_EDIT_REDUCER]:
    SpecificationAttributeEditReducer,
  [ReducerKeys.NEWS_REDUCER]: NewsReducer,

  [ReducerKeys.NEW_EDIT_REDUCER]: NewEditReducer,
  [ReducerKeys.BLOGS_SHOW_REDUCER]: BlogShowReducer,
  [ReducerKeys.NEWS_SHOW_REDUCER]: NewsShowReducer,
  [ReducerKeys.BLOGS_SHOW_DETAIL_REDUCER]: BlogShowDetailReducer,
  [ReducerKeys.NEWS_SHOW_DETAIL_REDUCER]: NewsShowDetailReducer,
  [ReducerKeys.TOPIC_SHOW_DETAIL_REDUCER]: TopicShowDetailReducer,
  [ReducerKeys.SETTINGS_GENERAL_REDUCER]: SettingsGeneralReducer,
  [ReducerKeys.SETTINGS_ADDITIONAL_REDUCER]: SettingsAdditionalReducer,
  [ReducerKeys.PRODUCT_PRINT_PDF_REDUCER]: ProductPrintPdfReducer,
  [ReducerKeys.DOCUMENT_LIST_REDUCER]: DocumentListReducer,
  [ReducerKeys.DOCUMENT_EDIT_REDUCER]: DocumentEditReducer,
  [ReducerKeys.REPORTING_REDUCER]: ReportingReducer,
};

export const staticReducers = {
  // global
  [ReducerKeys.AUTH_REDUCER]: AuthReducer,
  [ReducerKeys.TRANSL_REDUCER]: TranslationReducer,
  [ReducerKeys.NAVIGATION_REDUCER]: NavigationReducer,
  [ReducerKeys.THEME_REDUCER]: ThemeReducer,
  [ReducerKeys.MODAL_REDUCER]: ModalReducer,
  [ReducerKeys.HOST_REDUCER]: HostReducer,
  [ReducerKeys.PRODUCT_PRINT_PDF_REDUCER]: ProductPrintPdfReducer,
  [ReducerKeys.VIEW_TASK_DETAIL]: ViewTaskReducer,
  [ReducerKeys.VIEW_USER_INFO]: ViewUserInfoReducer,
  [ReducerKeys.SEND_MAIL_REDUCER]: SendMailReducer,
  [ReducerKeys.COMMON_REDUCER]: CommonReducer,
  [ReducerKeys.FCM_REDUCER]: FCMReducer,
};

// export default
function createReducer(asyncReducers = {}, store = {}) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
}

const rootReducer =
  (asyncReducers = {}, store = {}) =>
  (state: any, action: any) => {
    // if (action.type === LOGOUT_TYPE) {
    //   // for all keys defined in your persistConfig(s)
    //   storage.removeItem('persist:root');
    //   console.log('LOGOUT USER !!!!!!!!!!');
    //   return createReducer(asyncReducers, store)(undefined, action);
    // }
    return createReducer(asyncReducers, store)(state, action);
  };

export default rootReducer;
